<script setup>
defineProps({
  events: { type: Array, required: true },
})
</script>

<template>
  <ol class="timeline">
    <li v-for="event in events" :key="event.id" class="timeline__item">
      <div>
        <strong>{{ event.event_type }}</strong>
        <span>{{ event.created_at }}</span>
      </div>
      <p>{{ event.actor_type }} · {{ event.actor_id }}</p>
      <details>
        <summary>metadata_json</summary>
        <pre>{{ JSON.stringify(event.metadata_json, null, 2) }}</pre>
      </details>
    </li>
  </ol>
</template>

<style scoped>
.timeline {
  display: grid;
  gap: var(--drama-space-md);
  padding: 0;
  margin: 0;
  list-style: none;
}

.timeline__item {
  display: grid;
  gap: var(--drama-space-sm);
  padding: var(--drama-space-md);
  border: 1px solid var(--drama-color-border);
  border-radius: var(--drama-radius-md);
  background: var(--drama-color-surface-alt);
}

.timeline__item div {
  display: flex;
  justify-content: space-between;
  gap: var(--drama-space-md);
}

.timeline__item p {
  margin: 0;
  color: var(--drama-color-text-muted);
  font-size: var(--drama-font-size-sm);
}

pre {
  max-width: 100%;
  overflow: auto;
  font-family: var(--vgs-font-mono);
  font-size: var(--drama-font-size-xs);
}
</style>
